/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Navigate, useLocation} from 'react-router-dom';
import urlRoutes from 'routers/url-routes';

interface IRedirect {
  to: string;
  replace?: boolean;
}

const Redirect = ({to = urlRoutes.login.path, ...props}: IRedirect): JSX.Element => {
  const {search, pathname} = useLocation();

  return <Navigate {...props} state={{from: pathname}} to={`${to}/${search || ''}`}/>;
};

export default Redirect;